import React , {Component} from 'react';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import TermsConditionPage from './terms';


class termsCondition extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div>
            <TermsConditionPage {...this.props}/>
            </div>
        )
    }
}

export const TermsCondition  = PnkConnect(termsCondition , '');